module.exports = __webpack_public_path__ + "static/media/13-iveco-mercedes.0c64a18a.jpg";